import { NodeTreeItem, Renderer } from 'djedi-json';

import {
  Container,
  Exhibition,
  Grid,
  GridItem,
  Image,
  Object,
  RichText,
  Vimeo,
} from 'components/cms';
import * as CMS_TYPES from 'consts/cms';

const config = {
  components: [
    { Component: Exhibition, type: CMS_TYPES.DJEDI_EXHIBITION_TYPE },
    { Component: Image, type: CMS_TYPES.DJEDI_IMAGE_TYPE },
    { Component: RichText, type: CMS_TYPES.DJEDI_RICH_TEXT_TYPE },
    { Component: Grid, type: CMS_TYPES.DJEDI_LAYOUT_GRID_TYPE },
    { Component: GridItem, type: CMS_TYPES.DJEDI_LAYOUT_GRID_ITEM_TYPE },
    { Component: Vimeo, type: CMS_TYPES.DJEDI_VIMEO_TYPE },
    { Component: Object, type: CMS_TYPES.DJEDI_OBJECT_TYPE },
    { Component: Container, type: CMS_TYPES.DJEDI_LAYOUT_CONTAINER_TYPE },
  ],
};

const ExhibitionRenderer: React.FCWithChildren<{ tree: NodeTreeItem }> = ({ tree }) => {
  return <Renderer tree={tree} config={config} />;
};

export default ExhibitionRenderer;
